module.exports = __webpack_public_path__ + "static/assets/1640b6d968e0a0e13bc3c309a616deaa.svg";